import styled from "styled-components";

const DepartmentItem = styled.div`
    width: fit-content;
    height: fit-content;
    .badge_expired {
        background-color: #F44336;
        color: #fff;
        padding: .4rem;
    }
    > button.active, > .active button {
        background-color: ${props => props.color+"30"};
        color: ${props => props.color};
        transition: all .3s;
    }
    > div{
        > span {
            user-select: none;
            background: ${props => props.theme.bg} !important;
            color: #fff !important;
        }
    }
    button {
        margin-left: 0;
         &:hover{
            background-color: transparent;
            color: ${props => props.color} ;
        }
        &.active, .active:hover{
            background-color: ${props => props.color+"30"};
            color: ${props => props.color};
            transition: all .3s;
            border:1px solid transparent;
        }
        color: #E0E0E0;
        border: 1px solid currentColor;
        padding: 8px 10px;
        min-width: unset;
        min-height: unset;
        max-height: 25px;
        font-size: .75rem;
        font-weight: bold;
        transition: background-color 2ms;
        text-transform: uppercase;
    }`
const DepartmentContainer = styled.div`

`
const DepartmentList = styled.div`
    display: flex;
    flex-wrap: wrap;
    grid-gap: 12px;
`

export {DepartmentItem,DepartmentContainer,DepartmentList}